<template>
    <div>
        <create-variable-card card-type="recommendations"/>
        <set-country-af0-start-date-card />
        <create-calculation-card/>
        <calculation-list-table/>
    </div>
</template>

<script>

import CalculationListTable from '../../../components/calculation-table/CalculationListTable';
import CreateVariablesCard from '../../../components/calculation-table/CreateVariablesCard';
import CreateCalculationCard from '../../../components/calculation-table/CreateCalculationCard';
import SetCountryAF0StartDateCard from '@/components/calculation-table/SetCountryAF0StartDateCard.vue';
import { mapState } from 'vuex';

export default {
    name: 'CalculationTableView',
    components: {
        'create-variable-card': CreateVariablesCard,
        'create-calculation-card': CreateCalculationCard,
        'calculation-list-table': CalculationListTable,
        'set-country-af0-start-date-card': SetCountryAF0StartDateCard
    },
    computed: {
        ...mapState('culture', ['cultures']),
        ...mapState('soil', ['soilTypes']),
        ...mapState('rec', ['tableData']),
        ...mapState('calculation', ['calculationData']),
    },
};


</script>

<style scoped>

</style>